import {getResource, postForm} from './BaseRequests'

export const fetchCart = (success, fail) => {
    getResource("cart").then(success).catch(fail)
}


export const addProductToCart = (product_id, quantity=1) => {
    return postForm("cart", {"action": "add", "id": product_id, "quantity": quantity})
}

export const deleteProductFromCart = (product_id) => {
    return postForm("cart", { "action": "remove", "id": product_id})
}

export const setProductQuantity = (product_id, quantity) => {
    return postForm("cart", { "action": "set_quantity", "id": product_id, "quantity": quantity })
}

export const postGroupDelivery = (group_id, delivery) => {
    return postForm("cart", { "action": "set_delivery", "id": group_id, "delivery": delivery })
}

export const postGroupOptimise = (group_id, optimise) => {
    return postForm("cart", { "action": "set_optimise", "id": group_id, "optimise": optimise })
}

// TODO pass through total cart price as a sanity check incase cart has got out of sync
export const fetchCheckout = () =>{
    return postForm("checkout")
}

export const postPurchaseGoldMembership = () =>{
    return postForm("purchase_gold_membership")
}